import { render, staticRenderFns } from "./RTypePlaces.vue?vue&type=template&id=449b6714&"
import script from "./RTypePlaces.vue?vue&type=script&lang=js&"
export * from "./RTypePlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RTypePlaces.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449b6714')) {
      api.createRecord('449b6714', component.options)
    } else {
      api.reload('449b6714', component.options)
    }
    module.hot.accept("./RTypePlaces.vue?vue&type=template&id=449b6714&", function () {
      api.rerender('449b6714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/RTypePlaces/RTypePlaces.vue"
export default component.exports